 
import { createStore, applyMiddleware } from "redux";
// redux-thunk 3 dropped its default export in favour of a named one.
import { thunk as thunkMiddleware } from "redux-thunk";
import apiGetMiddleware from "./middleware/apiGetMiddleware";
import apiPutMiddleware from "./middleware/apiPutMiddleware";
import apiPostImageMiddleware from "./middleware/apiPostImageMiddleware";
import apiDeleteMiddleware from "./middleware/apiDeleteMiddleware";
import apiPostMiddleware from "./middleware/apiPostMiddleware";
import apiPutPostImageMiddleware from "./middleware/apiPutPostImageMiddleware";
import rootReducer from "./rootReducer";

export const configureStore = (preloadedState) =>
  createStore(
    rootReducer,
    preloadedState,
    applyMiddleware(
      thunkMiddleware,
      apiGetMiddleware,
      apiPutMiddleware,
      apiDeleteMiddleware,
      apiPostImageMiddleware,
      apiPostMiddleware,
      apiPutPostImageMiddleware
    )
  );
